import React, { useState } from "react";
import ChatHistory from "./components/chat-history/chat-history";
import NewChats from "./components/new-chats/new-chats";
import styles from "./chat-sidebar.module.css";

const ChatSidebar = ({ selectedChat, setSelectedChat, chatRules }) => {
  const [showNewChat, setShowNewChat] = useState(false);

  return (
    <div className={styles["chat-sidebar-container"]}>
      <ChatHistory
        showNewChat={showNewChat}
        setShowNewChat={setShowNewChat}
        selectedChat={selectedChat}
        setSelectedChat={setSelectedChat}
        chatRoles={chatRules?.can_see || []}
      />
      <div className={`${styles["new-chat-overlay"]} ${styles[showNewChat ? "slide-in" : "slide-out"]}`}>
        <NewChats
          showNewChat={showNewChat}
          setShowNewChat={setShowNewChat}
          selectedChat={selectedChat}
          setSelectedChat={setSelectedChat}
          chatRoles={chatRules?.can_message || []}
        />
      </div>
    </div>
  );
};

export default ChatSidebar;
